import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import MultichoiceCreatorPage from './MultichoiceCreatorPage';
import { Spinner } from 'components/Spinner/Spinner';
import services from 'api/services';

const { TestService } = services;

export const MultichoiceCreatorContext = React.createContext();

export default function MultichoiceCreator() {
  const { testId, questionId } = useParams();

  const [test, setTest] = useState({});
  const [questions, setQuestions] = useState([]);
  const [question, setQuestion] = useState({});
  const [options, setOptions] = useState([]);
  const [paragraph, setParagraph] = useState({});
  const [paragraphs, setParagraphs] = useState([]);

  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPageLoading(true);
        const { test, questions, question, options, paragraph, paragraphs } = await TestService.loadMCQTest(
          testId,
          questionId
        );
        setTest(test ?? {});
        setQuestions(questions ?? []);
        setQuestion(question ?? {});
        setOptions(options ?? []);
        setParagraph(paragraph ?? {});
        setParagraphs(paragraphs ?? []);
      } catch (error) {
        toast.error(error?.message ?? error);
      } finally {
        setPageLoading(false);
      }
    };
    fetchData();
  }, [testId, questionId, setTest, setQuestions, setQuestion, setOptions, setParagraph, setParagraphs, setPageLoading]);

  return (
    <MultichoiceCreatorContext.Provider
      value={{
        test,
        setTest,
        questions,
        setQuestions,
        question,
        setQuestion,
        options,
        setOptions,
        paragraph,
        setParagraph,
        paragraphs,
        setParagraphs,
      }}
    >
      {pageLoading ? <Spinner /> : <MultichoiceCreatorPage />}
    </MultichoiceCreatorContext.Provider>
  );
}
